"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaf = exports.node = void 0;
const node = (head, body, span) => ({
    kind: "Tree.node",
    head,
    body,
    span,
});
exports.node = node;
const leaf = (token) => ({
    kind: "Tree.leaf",
    token,
    span: token.span,
});
exports.leaf = leaf;
//# sourceMappingURL=tree.js.map